<section>
  <div class="body-container">
    <h2 class="c1">
      {{ "translate.notes.notesCatalog" | translate }}
    </h2>

    <section class="header" formEnhance [callback]="search">
      <div class="l-flex l-flex-wrap t-panel l-align-y">
        <input-wrap>
          <input
            class="t-input"
            type="text"
            [(ngModel)]="filterNoteText"
            placeholder="{{ 'translate.notes.filterTxt' | translate }}"
            (keypress)="onKeyPress($event)"
          />
        </input-wrap>

        <span class="spacer t-space--med"></span>
        <button class="t-button t-button--flat" (click)="search()">
          {{ "translate.general.search" | translate }}
        </button>
        <span class="spacer t-space--small"></span>
        <button class="t-button-outline c-c1" (click)="clearSearch()">
          {{ "translate.general.clearFilter" | translate }}
        </button>
      </div>

      <button
        *ngIf="allowCreate"
        (click)="createNote()"
        class="t-button-outline"
      >
        {{ "translate.notes.createNew" | translate }}
      </button>
    </section>

    <div class="tasks-container">
      <section>
        <div
          *ngIf="data && data.length == 0 && !loading"
          role="alert"
          class="c-alert t-alert-info"
        >
          {{ "translate.alert.noResults" | translate }}
        </div>

        <loader *ngIf="loading"></loader>

        <ui-table
          *ngIf="data && !runningNew"
          [isWrapped]="false"
          [tblColor]="true"
          [data]="data"
          [dense]="false"
          [tblRoundBottom]="true"
          [numberOfRows]="numberOfRows"
          [totalRecords]="searchMetaData.totalRecords"
          (requestUpdate)="loadDataOnPagination($event)"
          [displayFilter]="['id', 'he', 'en', 'cn']"
          [templates]="[
            {
              title: 'translate.general.statusDescr',
              template: status
            }
          ]"
          (onRowSelect)="onRowSelect($event)"
        ></ui-table>
      </section>
    </div>
  </div>
</section>

<ng-template #status let-row="row">
  <div class="status">
    <span
      class="stage-circle"
      [style.background-color]="getStatusColor(row)"
    ></span>
    {{ row.statusDescr }}
  </div>
</ng-template>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayEditNote = false"
  [isOpen]="displayEditNote"
>
  <edit-preset-note
    *ngIf="displayEditNote"
    [note]="curNote"
    (onCancel)="displayEditNote = false"
    (onSave)="onSave()"
  ></edit-preset-note>
</modal-popup>
